module.exports = __webpack_public_path__ + "img/image03.77e731a2.jpg";